import React from 'react'

interface StepProgressIndicatorProps {
  currentStep: number
  totalSteps: number
  stepTitles: string[]
}

/**
 * Reusable step progress indicator component for multi-step forms
 * Shows current step number, visual progress circles, and step title
 */
const StepProgressIndicator: React.FC<StepProgressIndicatorProps> = ({
  currentStep,
  totalSteps,
  stepTitles
}) => {
  return (
    <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
      <div className="forceBlack" style={{ fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '1rem' }}>
        Step {currentStep} of {totalSteps}
      </div>
      <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'nowrap' }}>
        {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => (
          <div
            key={step}
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              backgroundColor: currentStep >= step ? '#232043' : 'inherit',
              color: currentStep >= step ? 'yellow' : 'black',
              border: currentStep >= step ? 'none' : 'black 2px solid',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '0.9rem'
            }}
          >
            {step}
          </div>
        ))}
      </div>
      <div className="forceBlack" style={{ marginTop: '1rem', fontSize: '1.5rem', fontWeight: 'bold' }}>
        {stepTitles[currentStep - 1]}
      </div>
    </div>
  )
}

export default StepProgressIndicator
